import * as ambassadorWixPricingPlansV2Plan from './pricing-plans-v2-plan-plans.http.js';
import * as ambassadorWixPricingPlansV2PlanTypes from './pricing-plans-v2-plan-plans.types.js';
import * as ambassadorWixPricingPlansV2PlanUniversalTypes from './pricing-plans-v2-plan-plans.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listPublicPlans(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPricingPlansV2PlanUniversalTypes.ListPublicPlansRequest,
  ambassadorWixPricingPlansV2PlanTypes.ListPublicPlansRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.ListPublicPlansResponse,
  ambassadorWixPricingPlansV2PlanTypes.ListPublicPlansResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.listPublicPlans(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/plans/public',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPublicPlans(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2PlanUniversalTypes.QueryPublicPlansRequest,
  ambassadorWixPricingPlansV2PlanTypes.QueryPublicPlansRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.QueryPublicPlansResponse,
  ambassadorWixPricingPlansV2PlanTypes.QueryPublicPlansResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.queryPublicPlans(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/plans/public/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPlan(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixPricingPlansV2PlanUniversalTypes.GetPlanRequest,
  ambassadorWixPricingPlansV2PlanTypes.GetPlanRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.GetPlanResponse,
  ambassadorWixPricingPlansV2PlanTypes.GetPlanResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixPricingPlansV2Plan.getPlan(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/plans/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listPlans(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPricingPlansV2PlanUniversalTypes.ListPlansRequest,
  ambassadorWixPricingPlansV2PlanTypes.ListPlansRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.ListPlansResponse,
  ambassadorWixPricingPlansV2PlanTypes.ListPlansResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixPricingPlansV2Plan.listPlans(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/plans',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPlanStats(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPricingPlansV2PlanUniversalTypes.GetPlanStatsRequest,
  ambassadorWixPricingPlansV2PlanTypes.GetPlanStatsRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.GetPlanStatsResponse,
  ambassadorWixPricingPlansV2PlanTypes.GetPlanStatsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.getPlanStats(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/plans/stats',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createPlan(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2PlanUniversalTypes.CreatePlanRequest,
  ambassadorWixPricingPlansV2PlanTypes.CreatePlanRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.CreatePlanResponse,
  ambassadorWixPricingPlansV2PlanTypes.CreatePlanResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixPricingPlansV2Plan.createPlan(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/plans',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePlan(): __PublicMethodMetaInfo<
  'PATCH',
  { planId: string },
  ambassadorWixPricingPlansV2PlanUniversalTypes.UpdatePlanRequest,
  ambassadorWixPricingPlansV2PlanTypes.UpdatePlanRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.UpdatePlanResponse,
  ambassadorWixPricingPlansV2PlanTypes.UpdatePlanResponse
> {
  const payload = { plan: { id: ':planId' } } as any;

  const getRequestOptions = ambassadorWixPricingPlansV2Plan.updatePlan(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/plans/{plan.id}',
    pathParams: { planId: 'planId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setPlanVisibility(): __PublicMethodMetaInfo<
  'PUT',
  { id: string },
  ambassadorWixPricingPlansV2PlanUniversalTypes.SetPlanVisibilityRequest,
  ambassadorWixPricingPlansV2PlanTypes.SetPlanVisibilityRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.SetPlanVisibilityResponse,
  ambassadorWixPricingPlansV2PlanTypes.SetPlanVisibilityResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.setPlanVisibility(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v2/plans/{id}/visibility',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function makePlanPrimary(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2PlanUniversalTypes.MakePlanPrimaryRequest,
  ambassadorWixPricingPlansV2PlanTypes.MakePlanPrimaryRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.MakePlanPrimaryResponse,
  ambassadorWixPricingPlansV2PlanTypes.MakePlanPrimaryResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.makePlanPrimary(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/plans/{id}/make-primary',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function clearPrimary(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2PlanUniversalTypes.ClearPrimaryRequest,
  ambassadorWixPricingPlansV2PlanTypes.ClearPrimaryRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.ClearPrimaryResponse,
  ambassadorWixPricingPlansV2PlanTypes.ClearPrimaryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.clearPrimary(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/plans/clear-primary',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archivePlan(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2PlanUniversalTypes.ArchivePlanRequest,
  ambassadorWixPricingPlansV2PlanTypes.ArchivePlanRequest,
  ambassadorWixPricingPlansV2PlanUniversalTypes.ArchivePlanResponse,
  ambassadorWixPricingPlansV2PlanTypes.ArchivePlanResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Plan.archivePlan(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/plans/{id}/archive',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Plan as PlanOriginal,
  StringList as StringListOriginal,
  Pricing as PricingOriginal,
  PricingPricingModelOneOf as PricingPricingModelOneOfOriginal,
  Recurrence as RecurrenceOriginal,
  Duration as DurationOriginal,
  PeriodUnit as PeriodUnitOriginal,
  PeriodUnitWithLiterals as PeriodUnitWithLiteralsOriginal,
  Money as MoneyOriginal,
  FeeConfig as FeeConfigOriginal,
  Fee as FeeOriginal,
  AppliedAt as AppliedAtOriginal,
  AppliedAtWithLiterals as AppliedAtWithLiteralsOriginal,
  ListPublicPlansRequest as ListPublicPlansRequestOriginal,
  ListPublicPlansResponse as ListPublicPlansResponseOriginal,
  PublicPlan as PublicPlanOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryPublicPlansRequest as QueryPublicPlansRequestOriginal,
  QueryV2 as QueryV2Original,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryPublicPlansResponse as QueryPublicPlansResponseOriginal,
  GetPlanRequest as GetPlanRequestOriginal,
  GetPlanResponse as GetPlanResponseOriginal,
  ListPlansRequest as ListPlansRequestOriginal,
  ArchivedFilter as ArchivedFilterOriginal,
  ArchivedFilterWithLiterals as ArchivedFilterWithLiteralsOriginal,
  PublicFilter as PublicFilterOriginal,
  PublicFilterWithLiterals as PublicFilterWithLiteralsOriginal,
  ListPlansResponse as ListPlansResponseOriginal,
  GetPlanStatsRequest as GetPlanStatsRequestOriginal,
  GetPlanStatsResponse as GetPlanStatsResponseOriginal,
  CreatePlanRequest as CreatePlanRequestOriginal,
  CreatePlanResponse as CreatePlanResponseOriginal,
  UpdatePlanRequest as UpdatePlanRequestOriginal,
  UpdatePlanResponse as UpdatePlanResponseOriginal,
  BuyerCanCancelUpdated as BuyerCanCancelUpdatedOriginal,
  SetPlanVisibilityRequest as SetPlanVisibilityRequestOriginal,
  SetPlanVisibilityResponse as SetPlanVisibilityResponseOriginal,
  MakePlanPrimaryRequest as MakePlanPrimaryRequestOriginal,
  MakePlanPrimaryResponse as MakePlanPrimaryResponseOriginal,
  ClearPrimaryRequest as ClearPrimaryRequestOriginal,
  ClearPrimaryResponse as ClearPrimaryResponseOriginal,
  ArchivePlanRequest as ArchivePlanRequestOriginal,
  ArchivePlanResponse as ArchivePlanResponseOriginal,
  PlanArchived as PlanArchivedOriginal,
  BulkArchivePlanRequest as BulkArchivePlanRequestOriginal,
  BulkArchivePlanResponse as BulkArchivePlanResponseOriginal,
  BulkPlanResult as BulkPlanResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  ArrangePlansRequest as ArrangePlansRequestOriginal,
  ArrangePlansResponse as ArrangePlansResponseOriginal,
  CountPlansRequest as CountPlansRequestOriginal,
  CountPlansResponse as CountPlansResponseOriginal,
  GetPlansPremiumStatusRequest as GetPlansPremiumStatusRequestOriginal,
  GetPlansPremiumStatusResponse as GetPlansPremiumStatusResponseOriginal,
  SearchPlansRequest as SearchPlansRequestOriginal,
  SearchPlansResponse as SearchPlansResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  ListPublicPlansApplicationErrors as ListPublicPlansApplicationErrorsOriginal,
  QueryPublicPlansApplicationErrors as QueryPublicPlansApplicationErrorsOriginal,
  QueryPublicPlansValidationErrors as QueryPublicPlansValidationErrorsOriginal,
  GetPlanApplicationErrors as GetPlanApplicationErrorsOriginal,
  ListPlansApplicationErrors as ListPlansApplicationErrorsOriginal,
  ListPlansValidationErrors as ListPlansValidationErrorsOriginal,
  GetPlanStatsApplicationErrors as GetPlanStatsApplicationErrorsOriginal,
  CreatePlanApplicationErrors as CreatePlanApplicationErrorsOriginal,
  CreatePlanValidationErrors as CreatePlanValidationErrorsOriginal,
  UpdatePlanApplicationErrors as UpdatePlanApplicationErrorsOriginal,
  UpdatePlanValidationErrors as UpdatePlanValidationErrorsOriginal,
  SetPlanVisibilityApplicationErrors as SetPlanVisibilityApplicationErrorsOriginal,
  MakePlanPrimaryApplicationErrors as MakePlanPrimaryApplicationErrorsOriginal,
  ClearPrimaryApplicationErrors as ClearPrimaryApplicationErrorsOriginal,
  ArchivePlanApplicationErrors as ArchivePlanApplicationErrorsOriginal,
} from './pricing-plans-v2-plan-plans.types.js';
